// extracted by mini-css-extract-plugin
export default {"wrapper":"UserDetails_wrapper__O7HpR"};